<template>
  <div class="course-box">
    <div class="course-top">
      <el-select v-model="day_num" placeholder="请选择">
        <el-option :key="5" label="五天课表" :value="5"></el-option>
        <el-option :key="7" label="七天课表" :value="7"> </el-option>
      </el-select>
    </div>
    <div class="tea-course">
      <el-table ref="singleTable" border :data="tableData" :header-cell-style="{background:'#85bae2',color:'#fff'}" :cell-class-name='cellClassNameMethods' highlight-current-row height="calc(100% - 0px)">
        <el-table-column prop="course_time" align="center" width="200">
        </el-table-column>
        <el-table-column property="first_day" label="第一天" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 ||scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-view"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==0">{{scope.row.first_day}}<i class="el-icon-view" @click="toOpen(scope.row.first_day,'1')"></i><i class="el-icon-video-play"
                @click="toOpen(scope.row.first_day,'2')"></i></el-button>
            <div v-else>{{scope.row.first_day}}</div>
          </template>
        </el-table-column>
        <el-table-column property="second_day" label="第二天" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 ||scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.second_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-view"></i></el-button>
            <div v-else>{{scope.row.second_day}}</div>
          </template>
        </el-table-column>
        <el-table-column property="third_day" label="第三天" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 ||scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.third_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-view"></i></el-button>
            <div v-else>{{scope.row.third_day}}</div>
          </template>
        </el-table-column>
        <el-table-column property="fourth_day" label="第四天" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 ||scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.fourth_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-view"></i></el-button>
            <div v-else>{{scope.row.fourth_day}}</div>
          </template>
        </el-table-column>
        <el-table-column property="fifth_day" label="第五天" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 || scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.fifth_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8&&day_num==5" @click="toOpen('结业典礼')">结业典礼<i class="el-icon-view"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen('每日总结+颁奖')">每日总结+结业典礼<i class="el-icon-view"></i></el-button>
            <div v-else>{{scope.row.fifth_day}}</div>
          </template>
        </el-table-column>
        <el-table-column property="sixth_day" label="第六天" align="center" v-if="day_num==7">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 ||scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.sixth_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-view"></i></el-button>
            <div v-else>{{scope.row.sixth_day}}</div>
          </template>
        </el-table-column>
        <el-table-column property="seventh_day" label="第七天" align="center" v-if="day_num==7">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.$index==2 ||scope.$index==6" @click="toOpen(scope.row.first_day)">{{scope.row.seventh_day}}<i class="el-icon-video-play"></i></el-button>
            <el-button type="text" v-else-if="scope.$index==8" @click="toOpen(scope.row.first_day)">{{scope.row.first_day}}<i class="el-icon-view"></i></el-button>
            <div v-else>{{scope.row.seventh_day}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="预览" :visible.sync="preview_obj.dialogVisible" width="900px" append-to-body @close="closeFn">
      <div class="" style="width:100%;height:600px" v-if="preview_obj.url.indexOf('ppt')>-1">
        <iframe id="iframe1" width="100%" height="100%" frameborder='no' border='0' marginwidth='0' marginheight='0' scrolling='no' allowtransparency='yes'
          :src="'https://view.officeapps.live.com/op/view.aspx?src='+preview_obj.url"></iframe>
      </div>
      <div class="demo-image__preview" v-if="preview_obj.url.indexOf('jpg')>-1">
        <el-image style="width: 100px; height: 100px" :src="preview_obj.url" :preview-src-list="[preview_obj.url]">
        </el-image>
      </div>
      <div class="demo-view__preview" v-if="preview_obj.url.indexOf('mp4')>-1">
        <video id="video-box" :src="preview_obj.url" controls="controls" :poster="preview_obj.url+'?x-oss-process=video/snapshot,t_10000,m_fast,w_800,f_png'"></video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      day_num: 5,
      tableData: [
        {
          course_time: "第一节",
          first_day: "导入课+前测",
          second_day: "自然拼读",
          third_day: "同步培优",
          fourth_day: "同步培优",
          fifth_day: "能力拓展",
          sixth_day: "考试冲刺",
          seventh_day: "职业考试",
        },
        {
          course_time: "第二节",
          first_day: "自然拼读",
          second_day: "自然拼读",
          third_day: "同步培优",
          fourth_day: "同步培优",
          fifth_day: "能力拓展",
          sixth_day: "考试冲刺",
          seventh_day: "职业考试",
        },
        {
          course_time: "眼保健操",
          first_day: "眼保健操",
          second_day: "眼保健操",
          third_day: "眼保健操",
          fourth_day: "眼保健操",
          fifth_day: "眼保健操",
          sixth_day: "眼保健操",
          seventh_day: "眼保健操",
        },
        {
          course_time: "第三节",
          first_day: "自然拼读",
          second_day: "自然拼读",
          third_day: "同步培优",
          fourth_day: "同步培优",
          fifth_day: "能力拓展",
          sixth_day: "考试冲刺",
          seventh_day: "职业考试",
        },
        {
          course_time: "第四节",
          first_day: "自然拼读",
          second_day: "自然拼读",
          third_day: "同步培优",
          fourth_day: "同步培优",
          fifth_day: "能力拓展",
          sixth_day: "考试冲刺",
          seventh_day: "职业考试",
        },
        {
          course_time: "第五节",
          first_day: "记忆方法(水果篮)",
          second_day: "记忆方法(地图)",
          third_day: "记忆方法(国旗)",
          fourth_day: "记忆方法(三十六计)",
          fifth_day: "记忆方法(魔方)",
          sixth_day: "记忆方法(人工智能编程)",
          seventh_day: "记忆方法(魔方)",
        },
        {
          course_time: "眼保健操",
          first_day: "眼保健操",
          second_day: "眼保健操",
          third_day: "眼保健操",
          fourth_day: "眼保健操",
          fifth_day: "眼保健操",
          sixth_day: "眼保健操",
          seventh_day: "眼保健操",
        },
        {
          course_time: "第六节",
          first_day: "自然拼读",
          second_day: "自然拼读",
          third_day: "同步培优",
          fourth_day: "同步培优",
          fifth_day: "能力拓展+结业测试",
          sixth_day: "考试冲刺",
          seventh_day: "能力拓展+结业测试",
        },
        {
          course_time: "结束",
          first_day: "每日总结+颁奖",
          second_day: "每日总结+颁奖",
          third_day: "每日总结+颁奖",
          fourth_day: "每日总结+颁奖",
          fifth_day: "每日总结+颁奖",
          sixth_day: "每日总结+颁奖",
          seventh_day: "结业典礼",
        },
      ],
      // 预览
      preview_obj: {
        title: "预览",
        dialogVisible: false,
        url: "",
      },
    };
  },
  methods: {
    cellClassNameMethods({ row, column, columnIndex }) {
      return "cell1-class";
    },
    closeFn(){
      const video = document.getElementById('video-box')
      if (video) {
        video.pause()
        video.currentTime = 0
      }
    },
    toOpen(val, type) {
      if (val == "导入课+前测") {
        if (type == 1) {
          this.preview_obj.url =
            "https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/%E3%80%8A%E5%8D%95%E8%AF%8D%E9%80%9F%E8%AE%B0%E8%AF%BE%E3%80%8B%E5%AF%BC%E5%85%A5%E8%AF%BE.pptx";
          this.preview_obj.dialogVisible = true;
        } else if (type == 2) {
          this.preview_obj.url =
            "https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/%E5%AF%BC%E5%85%A5%E8%AF%BE-%E5%AD%A6%E5%89%8D%E5%BF%85%E8%AF%BB.mp4";
          this.preview_obj.dialogVisible = true;
        }
      } else if (val == "结业典礼") {
        this.preview_obj.url =
          "https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/毕业典礼.jpg";
        this.preview_obj.dialogVisible = true;
      } else if (val == "眼保健操") {
        this.preview_obj.url =
          "https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/%E7%9C%BC%E4%BF%9D%E5%81%A5%E6%93%8D.mp4";
        this.preview_obj.dialogVisible = true;
      } else if (val == "每日总结+颁奖") {
        this.preview_obj.url =
          "https://pk-words.oss-cn-shanghai.aliyuncs.com/guide/%E6%AF%8F%E6%97%A5%E9%A2%86%E5%A5%96%E8%83%8C%E6%99%AF.pptx";
        this.preview_obj.dialogVisible = true;
      } else if (val == "记忆方法(水果篮)") {
        alert(val);
      } else if (val == "记忆方法(地图)") {
        alert(val);
      } else if (val == "记忆方法(国旗)") {
        alert(val);
      } else if (val == "记忆方法(三十六计)") {
        alert(val);
      } else if (val == "记忆方法(魔方)") {
        alert(val);
      } else if (val == "记忆方法(人工智能编程)") {
        alert(val);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.course-box {
  height: 100%;
}
.tea-course {
  height: calc(100% - 60px);
  margin-top: 20px;
  ::v-deep .el-table {
    .el-button {
      padding: 0;
      i {
        margin-left: 5px;
        font-size: 16px;
      }
      span {
        color: #5186c2;
      }
    }
  }
}
.course-top {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-table__row {
  .is-center:first-child {
    background-color: #85bae2;
    color: #fff;
    font-size: 16px;
    font-family: "Helvetica Neue";
    width: 100px;
  }
  &:hover {
    .el-table__cell:first-child {
      &.cell1-class {
        background-color: #ecf5ff !important;
        color: #333;
      }
    }
  }
}
::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #1565c0, #1e88e594);
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  // display: none !important;
}
::v-deep .el-dialog__body {
  // height: 700px;
}
.demo-image__preview {
  width: 100%;
  // height: 500px;
  ::v-deep .el-image {
    width: 100% !important;
    height: 100% !important;
  }
}
.demo-view__preview {
  width: 100%;
  #video-box {
    width: 100%;
  }
}
</style>
